export const inputTransforms = {
  uppercase: (value: string) => value.toUpperCase(),
  lowercase: (value: string) => value.toLowerCase(),
  trim: (value: string) => value.trim(),
} satisfies Record<string, (value: string) => string>;

export type InputTransformKey = keyof typeof inputTransforms;

export type InputTransform = InputTransformKey | ((value: string) => string);

export const resolveInputTransform = (
  transform: InputTransform,
): ((value: string) => string) =>
  typeof transform === 'function' ? transform : inputTransforms[transform];
